/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WarehouseResVo } from './WarehouseResVo';
import {
    WarehouseResVoFromJSON,
    WarehouseResVoFromJSONTyped,
    WarehouseResVoToJSON,
    WarehouseResVoToJSONTyped,
} from './WarehouseResVo';

/**
 * 
 * @export
 * @interface ResponseWarehouseResVo
 */
export interface ResponseWarehouseResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseWarehouseResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseWarehouseResVo
     */
    message?: string;
    /**
     * 
     * @type {WarehouseResVo}
     * @memberof ResponseWarehouseResVo
     */
    data?: WarehouseResVo;
}

/**
 * Check if a given object implements the ResponseWarehouseResVo interface.
 */
export function instanceOfResponseWarehouseResVo(value: object): value is ResponseWarehouseResVo {
    return true;
}

export function ResponseWarehouseResVoFromJSON(json: any): ResponseWarehouseResVo {
    return ResponseWarehouseResVoFromJSONTyped(json, false);
}

export function ResponseWarehouseResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseWarehouseResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : WarehouseResVoFromJSON(json['data']),
    };
}

export function ResponseWarehouseResVoToJSON(json: any): ResponseWarehouseResVo {
    return ResponseWarehouseResVoToJSONTyped(json, false);
}

export function ResponseWarehouseResVoToJSONTyped(value?: ResponseWarehouseResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': WarehouseResVoToJSON(value['data']),
    };
}

